/* istanbul ignore file */
import React from 'react';

import { agentAnalyticsEnabledSelector } from '@lumapps/agent-hub/ducks/selectors';
import { canViewInstanceAnalytics, canViewPlatformAnalytics } from '@lumapps/analytics/ducks/selectors';
import { isAskAIEnabled } from '@lumapps/ask-ai/ducks/selectors';
import { isBeekeeperAdminAllowed } from '@lumapps/beekeeper/ducks/selectors';
import { canAccessBroadcast } from '@lumapps/broadcasts/ducks/selectors';
import { hasBeekeeperFormsAccess } from '@lumapps/forms/ducks/selectors';
import { isLearningEnabled } from '@lumapps/learning/ducks/selectors';
import { permissionsSelector } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';
import { canViewSearchAnalytics } from '@lumapps/search-analytics/ducks/selectors';
import { isTasksEnabled } from '@lumapps/tasks/ducks/selectors';
import { isWorkflowsAllowed } from '@lumapps/workflows-back-office/ducks/selectors';

import { AnalyticsSideNavigation as UI, AnalyticsSideNavigationProps } from './AnalyticsSideNavigation';

export const AnalyticsSideNavigation: React.FC<Pick<AnalyticsSideNavigationProps, 'id'>> = (props) => {
    const hasSearchAnalyticsAccess = useSelector(canViewSearchAnalytics);
    const canViewPlatformEntry = useSelector(canViewPlatformAnalytics);
    const canViewInstanceEntry = useSelector(canViewInstanceAnalytics);
    const isFFAskAiEnabled = useSelector(isAskAIEnabled);
    const isAgentAnalyticsEnabled = useSelector(agentAnalyticsEnabledSelector);
    const permissions = useSelector(permissionsSelector);
    const learningEnabled = useSelector(isLearningEnabled);
    const hasBroadcastFF = useSelector(canAccessBroadcast);
    const areTasksEnabled = useSelector(isTasksEnabled);
    const hasFormsAccess = useSelector(hasBeekeeperFormsAccess);
    const hasWorkflowsAccess = useSelector(isWorkflowsAllowed);
    const isBkprAdminAllowed = useSelector(isBeekeeperAdminAllowed);
    const hasBroadcastAccess = hasBroadcastFF && canViewPlatformEntry;
    const hasSiteAnalyticsAccess = canViewInstanceEntry;
    const hasExtendedAnalyticsAccess = canViewPlatformEntry;
    const hasMobileAnalyticsAccess = canViewPlatformEntry;
    const hasAgentsAnalyticsAccess = canViewPlatformEntry && isAgentAnalyticsEnabled;
    const hasAskAiAccess = canViewPlatformEntry && isFFAskAiEnabled;
    const { canReadLearningAnalytics } = permissions.authorizations;
    const hasLearningAnalyticsAccess = canReadLearningAnalytics && learningEnabled;

    return (
        <UI
            {...props}
            hasSearchAnalyticsAccess={hasSearchAnalyticsAccess}
            hasSiteAnalyticsAccess={hasSiteAnalyticsAccess}
            hasExtendedAnalyticsAccess={hasExtendedAnalyticsAccess}
            hasMobileAnalyticsAccess={hasMobileAnalyticsAccess}
            hasLearningAnalyticsAccess={hasLearningAnalyticsAccess}
            hasAgentsAnalyticsAccess={hasAgentsAnalyticsAccess}
            hasAskAiAccess={hasAskAiAccess}
            hasBroadcastAccess={hasBroadcastAccess}
            hasTasksAccess={areTasksEnabled && isBkprAdminAllowed}
            hasFormsAccess={hasFormsAccess}
            hasWorkflowsAccess={hasWorkflowsAccess}
        />
    );
};
